import './error-template.scss';

import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';

import useAppNavigate from '@/shared/hooks/useAppNavigation';
import { ROUTES } from '@/shared/routes';

export type ErrorType = 'notFound' | 'oops';

interface IProps {
  type: ErrorType;
}

/**
 * Экран ошибки: иллюстрация antd Result, заголовок, описание и переход на главную.
 * Не зависит от каркаса — переиспользуется и как 404-роут, и как fallback для ErrorBoundary.
 */
const ErrorTemplate: React.FC<IProps> = ({ type }) => {
  const { t } = useTranslation();
  const { navigate } = useAppNavigate();
  const isOops = type === 'oops';

  return (
    <div className="error-template">
      <Result
        status={isOops ? '500' : '404'}
        title={t(isOops ? 'errors.oops.title' : 'errors.notFound.title')}
        subTitle={
          isOops ? (
            t('errors.oops.description')
          ) : (
            <>
              {t('errors.notFound.description1')}
              <br />
              {t('errors.notFound.description2')}
            </>
          )
        }
        extra={
          <Button type="primary" onClick={() => navigate(ROUTES.home)}>
            {t('errors.redirectHome')}
          </Button>
        }
      />
    </div>
  );
};

export default ErrorTemplate;
